import { createEvoClient, listPurchases, verifyConsent } from "@jti/evo-client";
import type { OlaApiContract, ResponseUserOfflinePurchases, ResponseValidateHash } from "@jti/rest-api-types";

export class OlaApiEvo implements OlaApiContract {
  private readonly client;

  constructor(
    baseUrl: string,
    tenantToken: string,
    ciamToken: string,
    protected userUuid: string,
    recaptchaId: string
  ) {
    this.client = createEvoClient({
      baseUrl,
      recaptchaId,
      tenantToken,
      ciamToken,
      throwOnError: true,
    });
  }

  async getOfflinePurchases(): Promise<ResponseUserOfflinePurchases> {
    const response = await listPurchases({
      client: this.client,
      path: {
        uuid: this.userUuid,
      },
    });

    return Promise.resolve({
      data: (response.data?.data ?? []).map(({ external_created_at, items, type, uuid }) => ({
        action_id: uuid,
        datetime: external_created_at,
        type,
        items,
      })),
    });
  }

  async validateHash(hash: string): Promise<ResponseValidateHash> {
    const { data } = await verifyConsent({
      client: this.client,
      path: {
        hash,
      },
    });

    return {
      token: data?.token ?? null,
    };
  }
}
